export default function promiseReduce(items, callback, initialValue) {
  return items.reduce(
    (promise, item, index) =>
      promise.then((previousResult) => callback(previousResult, item, index)),
    Promise.resolve(initialValue),
  )
}
